import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
// Icons
import { IoMdMenu } from 'react-icons/io';
// Images
import MainLogoImage from '../../assets/images/logos/ascari-building-contractors-orange-logo-letter-black.png';
// Context
import { useUser } from '../../context/UserContext';
// Constants
import { CompanyName, CONTACT_PAGE_URL, HOME_PAGE_URL } from '../../utils/Constants';
// Nav data
import { getNavLinkItemsArray } from '../../utils/data/NavData';
import SocialMediaIconCta from '../footer/SocialMediaIconCta';

function Navbar() {
  const { user } = useUser();
  const navLinkItemsArray = getNavLinkItemsArray(user);

  const [isPhoneNavOpen, setIsPhoneNavOpen] = useState(false);

  const togglePhoneNav = () => {
    setIsPhoneNavOpen((prev) => !prev);
  };

  return (
    <nav
      role='navigation'
      aria-label='Main Navigation'
      className='relative bg-colour5 shadow-md h-fit border-t-2 border-b-2 border-solid border-colour6'
    >
      <section className='grid grid-cols-reg lg:grid-flow-col px-4 py-4'>
        <section className='grid items-center'>
          <NavLink
            to={HOME_PAGE_URL}
            className={`grid grid-flow-col gap-1 items-center`}
          >
            <div>
              <img
                src={MainLogoImage}
                alt={`${CompanyName} business logo - Colour2 Logo`}
                className='min-w-10 w-10 lg:w-16 h-auto cursor-pointer active:scale-95'
              />
            </div>
            <div className='grid h-fit'>
              <span className='font-semibold text-sm leading-3 h-fit'>
                <span className='text-slate-700'>Ascari</span> Building <br /> Contractors
              </span>
            </div>
          </NavLink>
        </section>

        {/* Large cta */}
        <section className='hidden xl:grid'>
          <div className='grid items-center justify-center'>
            <a href={CONTACT_PAGE_URL} aria-label={`Contact now button for ${CompanyName}`} className='bg-colour4 hover:bg-colour3 hover:text-colour5 border-colour3 border-solid border-2 text-colour2 px-4 py-1 rounded-lg font-semibold shadow-md'>CONTACT NOW</a>
          </div>
        </section>

        <section className='grid grid-flow-col gap-4 justify-end'>
          {/* Mobile screen */}
          <button
            aria-label='Toggle navigation menu'
            onClick={togglePhoneNav}
            className='grid md:hidden w-fit h-fit items-center justify-center text-3xl text-colour2 cursor-pointer'
          >
            <IoMdMenu className='active:scale-90 duration-300' />
          </button>

          {/* Large screen */}
          <ul className='hidden lg:grid grid-flow-col gap-6 items-center text-colour2'>
            {navLinkItemsArray.map(({ path, label }) => (
              <NavItem key={label} url={path} title={label} />
            ))}
          </ul>

          {/* Social media */}
          <div className='hidden lg:grid'>
            <SocialMediaIconCta />
          </div>
        </section>
      </section>

      {/* Phone navbar */}
      <section
        className={`phone-nav absolute top-full left-0 w-full bg-colour5 border-t-2 border-b-2 border-solid border-colour6 transition-transform duration-300 py-10 ${
          isPhoneNavOpen
            ? 'translate-y-0 opacity-100'
            : '-translate-y-full opacity-0'
        }`}
      >
        <ul className='grid gap-8 items-center justify-center text-center text-colour2'>
          {navLinkItemsArray.map(({ path, label }) => (
            <NavItem key={label} url={path} title={label} />
          ))}

          {/* Social media */}
          <SocialMediaIconCta />
        </ul>
      </section>
    </nav>
  );
}

const NavItem = ({ url, title }) => {
  return (
    <li className='active:scale-90'>
      <NavLink
        to={url}
        aria-label={`${title} page navigation tab`}
        className={`text-xl md:text-base lg:text-sm font-medium hover:text-colour1 font-poppins hover:brightness-90 duration-200 active:scale-75 ${url === '/contact' ? 'border-2 border-solid border-colour6 hover:text-colour6 px-2 py-1 rounded-lg bg-colour1 shadow-md' : ''}`}
        aria-current={({ isActive }) => (isActive ? 'page' : undefined)}
      >
        {title}
      </NavLink>
    </li>
  );
};

export default Navbar;
